import { memo, useEffect, useState } from 'react';

import { Form, Row } from 'app/components/layout';
import { resources } from 'app/services';
import { IResource } from 'app/models';

import { ProfileView } from './profile';

export interface IMediaView {
  mediaId: any;
}

export const MediaView = memo(({ mediaId }: IMediaView) => {
  const [values, setValues] = useState({} as IResource);

  useEffect(() => {
    if (!mediaId) return;

    resources.get(mediaId).then(({ success, data }) => {
      if (!success) return;

      setValues(data);
    });
  }, [mediaId]);

  return (
    <Form responsive={true}>
      <Row>
        <div className="p-3 flex-1">
          <ProfileView profileId={values.objectId} />
        </div>
        <div className="p-3 flex-1">
          { [3].includes(values.type) ? (
            <video controls src={values.url} poster={values.cover} className="mx-auto block" style={{ maxWidth: '100%', maxHeight: '80vh' }} />
          ) : (
            <img src={values.url} alt={values.id} className="mx-auto block" style={{ maxWidth: '100%', maxHeight: '80vh' }} />
          ) }
        </div>
      </Row>
    </Form>
  );
});
